import React from 'react';
import './App.less';
import { 
  Button,
  Typography, 
  Divider,
  Row, 
  Col,
  Card,
  Image,
  Space,
  Avatar,
  Tabs
} from 'antd';

import Sticky from 'react-sticky-el';
import { Link } from "react-router-dom";
import DesignTech from './components/DesignTech'
import UIUX from './components/UIUX'
import MotionGraphics from './components/MotionGraphics'
import SideBar from './components/SideBar'

const { 
  Text, 
  Title
} = Typography;

const gridStyle = {
  width: '50%',
  textAlign: 'center',
};

const { TabPane } = Tabs;

function callback(key) {
  console.log(key);
}

function Home() {
  return (
    <div>
      <Row className="m48-t m80-b" justify="space-between">
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>

            <Col xs={22} sm={22} md={22} lg={5} xl={5}>
              <SideBar />
            </Col>
            <Col xs={1} sm={1} md={1} lg={0} xl={0}></Col>

            <Col xs={0} sm={0} md={0} lg={1} xl={1}></Col>

            <Col xs={1} sm={1} md={1} lg={0} xl={0}></Col>


            <Col  xs={22} sm={22} md={22} lg={11} xl={11}  className="contentMob">
              <Tabs defaultActiveKey="1" onChange={callback}>
                <TabPane tab="Design + Tech" key="1">
                  <DesignTech />
                </TabPane>
                <TabPane tab="UI/UX" key="2">
                  <UIUX />
                </TabPane>
                <TabPane tab="Motion + Graphics" key="3">
                  <MotionGraphics />
                </TabPane>
              </Tabs>
            </Col>
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
        </Row>
    </div>
  );
}

export default Home;